// File: src/App.tsx
import { Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { Header } from "./components/layout/Header";
import { Footer } from "./components/layout/Footer";
import { HomePage } from "./pages/HomePage";
import { DocsPage } from "./pages/DocsPage";
import AboutPage from "./pages/AboutPage";
import WordLookupPage from "./pages/WordLookUpPage";
import WordFinderPage from "./pages/WordFinderPage";
import AnagramSolverPage from "./pages/AnagramSolverPage";
import MagicSearchPage from "./pages/MagicSearchPage";
import PracticePage from "./pages/PracticePage";

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-page">
      <Header />

      <main className="flex-grow container mx-auto px-4 py-8">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/es" element={<HomePage />} />
          <Route path="/game" element={<div className="text-center p-8">Game Board will be here!</div>} />
          <Route path="/es/game" element={<div className="text-center p-8">Game Board will be here!</div>} />
          <Route path="/docs/:docName" element={<DocsPage />} />
          <Route path="/docs" element={<DocsPage />} />
          <Route path="/es/docs/:docName" element={<DocsPage />} />
          <Route path="/es/docs" element={<DocsPage />} />
          <Route path="/how-to-play" element={<div className="text-center p-8">How to Play - Coming Soon!</div>} />
          <Route path="/es/how-to-play" element={<div className="text-center p-8">How to Play - Coming Soon!</div>} />
          <Route path="/leaderboard" element={<div className="text-center p-8">Leaderboard - Coming Soon!</div>} />
          <Route path="/es/leaderboard" element={<div className="text-center p-8">Leaderboard - Coming Soon!</div>} />
          <Route path="/profile" element={<div className="text-center p-8">Profile - Coming Soon!</div>} />
          <Route path="/es/profile" element={<div className="text-center p-8">Profile - Coming Soon!</div>} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/es/about" element={<AboutPage />} />
          <Route path="/tech-stack" element={<Navigate to="/docs/tech_stack" replace />} />
          <Route path="/es/tech-stack" element={<Navigate to="/es/docs/tech_stack" replace />} />

          <Route path="/lookup" element={<WordLookupPage />} />
          <Route path="/word-finder" element={<WordFinderPage />} />
          <Route path="/anagram-solver" element={<AnagramSolverPage />} />
          <Route path="/magic" element={<MagicSearchPage />} />
          <Route path="/practice" element={<PracticePage />} />
          <Route path="/es/lookup" element={<WordLookupPage />} />
          <Route path="/es/word-finder" element={<WordFinderPage />} />
          <Route path="/es/anagram-solver" element={<AnagramSolverPage />} />
          <Route path="/es/magic" element={<MagicSearchPage />} />
          <Route path="/es/practice" element={<PracticePage />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
 }

export default App;
